import React from 'react';
import L from 'leaflet';
import { useMapStore } from 'contexts/RootStore.context';
import { observer } from 'mobx-react';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { style } from 'typestyle';
import { MAX_ZOOM_FOR_DISPLAY_CLUSTERS } from 'stores/MapStore';
import { Device } from 'types/device';
import { DeviceColor } from 'views/map/Styled';
import { DeviceMarker } from './DeviceMarker';

export const DeviceMarkers = observer(({ devices }: { devices: Device[] }) => {

  const { mapZoom } = useMapStore();

  return (
    <>
      {mapZoom < MAX_ZOOM_FOR_DISPLAY_CLUSTERS
        ? < MarkerClusterGroup
          iconCreateFunction={(cluster: any) => {
            const count = cluster.getChildCount();
            return new L.DivIcon({
              html: `<div>${count}</div>`,
              className: ClusterStyle,
              iconSize: L.point(40, 40, true),
            });
          }}
          chunkedLoading
          maxClusterRadius={80}
          spiderfyOnMaxZoom
          showCoverageOnHover={true}
        >
          {devices.map((device: Device) =>
            <DeviceMarker device={device} key={`device-${device.device_id}`} />
          )}
        </MarkerClusterGroup >
        :
        devices.map((device: Device) =>
          <DeviceMarker device={device} key={`device-${device.device_id}`} />
        )
      }
    </>
  );
})

const ClusterStyle = style({
  background: DeviceColor,
  borderRadius: '50%',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold'
})